'use client'

import { LandscapeListIcon } from '@/components/svg/landscape-list-icon/landscape-list-icon'
import { VerticalListIcon } from '@/components/svg/vertical-list-icon/vertical-list-icon'
import { Button } from '@/components/v3/atoms/button/button'
import { CardMobileVariant } from '@/components/v3/atoms/card/card'
import s from './list-view-toggle.module.scss'

type Props = {
  value: CardMobileVariant
  onChange: (view: CardMobileVariant) => void
}

// Mobile-only toggle between the landscape and vertical supplier list layouts.
// The selected button is solid black with a white icon; the unselected one is
// white with a black icon. Colors are driven by the active/inactive classes
// (not Button's variant) so the selected state stays black even while hovered or
// tapped. The icons use currentColor, so the button's text color drives them.
//
// Icon positions are fixed; each one selects the layout its glyph depicts — the
// left icon selects the vertical (image-left) layout, the right one selects the
// landscape (image-on-top) layout.
export const ListViewToggle = ({ value, onChange }: Props) => {
  return (
    <div className={s.toggle} role="group" aria-label="List view">
      <Button
        className={value === 'vertical' ? s.active : s.inactive}
        aria-pressed={value === 'vertical'}
        aria-label="Vertical list view"
        onClick={() => onChange('vertical')}
      >
        <LandscapeListIcon />
      </Button>
      <Button
        className={value === 'landscape' ? s.active : s.inactive}
        aria-pressed={value === 'landscape'}
        aria-label="Landscape list view"
        onClick={() => onChange('landscape')}
      >
        <VerticalListIcon />
      </Button>
    </div>
  )
}
